import React from 'react';
import * as RechartsNS from 'recharts';
import { applyApiBaseUrl } from './config-api.js';

// Available for any leftover legacy lookups; Recharts UMD-style access in charts.
window.React = React;
window.Recharts = RechartsNS;
applyApiBaseUrl();
